import { render, staticRenderFns } from "./HowToUploadZodiac.vue?vue&type=template&id=51edd3e2&scoped=true&"
import script from "./HowToUploadZodiac.vue?vue&type=script&lang=js&"
export * from "./HowToUploadZodiac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51edd3e2",
  null
  
)

export default component.exports